import SqFetch from 'typescript/application/sq_fetch';
import { _handleResponse } from 'typescript/clients/utilities/handle_http_response';
import { CountryCode, LanguageCode } from 'typescript/constants/localization';

export const CREATE_FINANCING_DISCLOSURES_URL =
  '/shop/api/v1/checkout/financing_disclosures/create';

/**
 * Create a financing disclosure document. Will only return a token on successful
 * creation, which is currently only for NY Installment orders.
 * @returns Disclosure document token if one was created.
 */
export const createFinancingDisclosures = async ({
  languageCode,
  orderNumber,
  countryCode,
  contractDate = new Date().toJSON(),
}: {
  languageCode: LanguageCode;
  orderNumber: string;
  countryCode: CountryCode;
  contractDate?: string;
}): Promise<{ disclosure_document_token: string | undefined }> => {
  const response = await SqFetch.post(CREATE_FINANCING_DISCLOSURES_URL, {
    language_code: languageCode,
    order_number: orderNumber,
    store_code: countryCode,
    contract_date: contractDate,
  });

  return _handleResponse(response);
};
